import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { StyleSheet } from "react-native";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../../utils";

type Props = {
  index: number;
  passenger: any;
  baggage: { label: string; value: string }[];
};

export default function PassengerSummaryItem({
  index,
  baggage,
  passenger,
}: Props) {
  const { CorporateFlightPrebookForm: cr, CorporateFlightProductSummary: crp } =
    useMobileContentResource();
  return (
    <BMView row spacing="xs">
      <BMText>{index + 1}.</BMText>
      <BMView flex style={styles.gapXXS}>
        <BMView spacing="xs">
          <BMText>
            {formatTitleCase(passenger.title)}. {passenger.fullname}
          </BMText>
          {passenger.documentDetail?.documentType === "PASSPORT" && (
            <BMView spacing="xs">
              {passenger.documentDetail.documentNo && (
                <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondary">
                  {cr.passengerFormPassportNumberFieldLabel}:{" "}
                  <BMText variant="uiSmallLi" ink="BMStyleTextInkPrimary">
                    {passenger.documentDetail.documentNo}
                  </BMText>
                </BMText>
              )}
              {passenger.documentDetail.issuingCountry && (
                <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondary">
                  {cr.passengerFormPassportCountryIssuanceFieldLabel}:{" "}
                  <BMText variant="uiSmallLi" ink="BMStyleTextInkPrimary">
                    {passenger.documentDetail.issuingCountry}
                  </BMText>
                </BMText>
              )}
            </BMView>
          )}
        </BMView>
        {!!baggage.length && (
          <BMText
            variant="uiSmallLi"
            ink="BMStyleTextInkSecondary"
            numberOfLines={2}
            style={styles.lineHeightLg}
          >
            {formatMessage(crp.facilityBaggage, { spec: " " })}
            {baggage.map(({ label, value }, i) => (
              <BMText
                variant="uiSmallLi"
                ink="BMStyleTextInkSecondary"
                key={`baggage-${i}`}
              >
                {label}{" "}
                <BMText variant="uiSmallLi" ink="BMStyleTextInkPrimary">
                  {value}
                  {i < baggage.length - 1 ? ", " : ""}
                </BMText>
              </BMText>
            ))}
          </BMText>
        )}
      </BMView>
    </BMView>
  );
}

function formatTitleCase(title: string) {
  return title
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const styles = StyleSheet.create({
  lineHeightLg: {
    lineHeight: BMPrimitives.BMSize.lg,
  },
  gapXXS: {
    gap: BMPrimitives.BMSize.xs / 2,
  },
});
